/**
 * @Author: Zewei
 * @Date:   2018-01-22T09:58:52+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-28T13:06:07+08:00
 */

import { UserConstants } from '../constants/user-constants';
import loginService from '../services/Login/login-service.js';
import { push } from 'react-router-redux';
import { store } from '../store/store.js';
import docCookies from '../utils/cookies.js';
import _util from '../utils/index.js';


// let routerRedux = require('react-router-redux');
//业务逻辑存在于action中.

export function addUser (username, email) {
    return dispatch =>{
        dispatch({
            type: UserConstants.ActionTypes.ADD,
            username: username,
            email: email
        })
    }
}

export function login (payload,callback) {
    return dispatch => {

        dispatch({
            type: UserConstants.ActionTypes.CHANGESUBMITTING,
            payload: {
                submitting: true,
            }
        })

        loginService.login(payload, (res) => {
            if (res.data.Success) {
                // console.log("routerRedux", routerRedux)
                dispatch({
                    type: UserConstants.ActionTypes.LOGINSUCCESS,
                    payload: {
                        res,
                        loginStatus: true,
                        submitting: false,
                        userInfo: res.data.Object
                    }
                })
                let userInfo = JSON.stringify(res.data.Object);
                window.localStorage.setItem('userInfo', userInfo);
                window.sessionStorage.setItem('token', res.data.Token);
                if(res.data.Object.language=="英语"){
                    store.dispatch(push('/employee/employee-home-en'));
                }else{
                    store.dispatch(push('/employee/employee-home'));
                }
                // window.location.href='/employee/employee-home'
            } else {
                // throw new Error('账号密码错误')
                callback(res)
                throw new Error('账号密码错误')
            }
        }, (err) => {
            dispatch({
                type: UserConstants.ActionTypes.LOGINFAILURE,
                payload: {
                    err,
                    loginStatus: false,
                    submitting: false
                 }
            })
        })
    }
}

export function fetchCurrentUser (status) {
    return dispatch => {
        // 如果localStorage中 无 用户信息 则返回登陆页面
        if (!window.localStorage.userInfo && !status) window.location.pathname = '/login';
        // 从 localStorage 获取 当前登录用户信息 e.g. 用户名、用户头像等
        const currentUser = window.localStorage.userInfo && JSON.parse(window.localStorage.userInfo);
        if (currentUser) {
            dispatch({
                type: UserConstants.ActionTypes.FETCHUSERSUCCESS,
                payload: {
                    currentUser
                }
            })
        }
    }
}

export function logout (payload) {
    return dispatch => {
        let cookiesKeys = docCookies.keys();
        loginService.logout((res) => {
           if (res.data === true) {
               cookiesKeys.forEach(i => docCookies.removeItem(i))
               window.localStorage.removeItem('userInfo');
               sessionStorage.removeItem("tabIndex");
               dispatch({
                   type: UserConstants.ActionTypes.LOGOUTSUCCESS
               })
               sessionStorage.removeItem("token")
               window.location.pathname = '/login';
           } else {
               throw new Error('登出失败')
           }
        }, (err) => {
            dispatch({
                type: UserConstants.ActionTypes.LOGOUTFAILURE
            })
            _util.errorTips('登出失败')
        })
    }
}
export function change_password (payload) {
    return dispatch => {
        store.dispatch(push('/employee/change-password'));
    }
}

export function change_second_password (payload) {
    return dispatch => {
        store.dispatch(push('/employee/change-second-password'));
    }
}

export function fetchDynamicMenu (params) {
    return dispatch => {
        loginService.fetchAuthInfo(params, (res) => {
            if (res.data) {
                dispatch({
                    type: UserConstants.ActionTypes.FETCHAUTHSUCCESS,
                    payload: {
                        authInfo: res.data
                    }
                })
            } else {
                throw new Error(res.data.error)
            }
        }, (err) => {
            dispatch({
                type: UserConstants.ActionTypes.FETCHAUTHFAILURE,
                payload: {
                    err
                }
            })
        })
    }
}

export function fetchUserDynamicMenu (params) {
    return dispatch => {
        loginService.fetchUserAuthInfo(params, (res) => {
            // console.log(res.data.Object);
            if (res.data) {
                dispatch({
                    type: UserConstants.ActionTypes.FETCHUSERAUTHSUCCESS,
                    payload: {
                        employeeUserInfo: res.data.Object
                    }
                })
            } else {
                throw new Error(res.data.error)
            }
        }, (err) => {
            dispatch({
                type: UserConstants.ActionTypes.FETCHUSERAUTHSUCCESS,
                payload: {
                    err
                }
            })
        })
    }
}
export function fetchUserMobileAuthInfo (params) {
    return dispatch => {
        loginService.fetchUserMobileAuthInfo(params, (res) => {
            // console.log(res.data.Object.Menus);
            if (res.data) {
                let userInfo = JSON.stringify(res.data.Object);
                window.localStorage.setItem('userInfo', userInfo);
                dispatch({
                    type: UserConstants.ActionTypes.FETCHUSERMOBILEAUTHSUCCESS,
                    payload: {
                        mobileUserInfo: res.data.Object
                    }
                })
            } else {
                throw new Error(res.data.error)
            }
        }, (err) => {
            dispatch({
                type: UserConstants.ActionTypes.FETCHUSERMOBILEAUTHSUCCESS,
                payload: {
                    err
                }
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/user-actions.js